import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import Logo, {LOGO_SIZE} from '../../forecast-app/shared/components/logo/Logo';
import {createFragmentContainer, graphql} from 'react-relay';
import styled from 'styled-components';

export const LogoWrapper = styled.div`
	display: inline-block;
	height: 2.6rem;
	padding: 0.75rem 0;
	margin: 0 2rem 0 1rem;
	vertical-align: middle;
`;

class MissionControlHeader extends Component {
	constructor(props) {
		super(props);

		Sentry.configureScope(scope => {
			scope.setUser({
				email: props.viewer.email,
				id: atob(props.viewer.actualPersonId).replace('Person:', ''),
				company_id: atob(props.viewer.company.id).replace('Company:', ''),
				name: props.viewer.firstName + ' ' + props.viewer.lastName,
				company_name: props.viewer.company.name,
			});
		});
	}
	goto(url) {
		this.props.history.push(url);
	}

	getButton(url, text, index) {
		const currentUrl = window.location.pathname;
		return (
			<button key={index} className={'tab' + (url === currentUrl ? ' selected' : '')} onClick={this.goto.bind(this, url)}>
				{text}
			</button>
		);
	}

	render() {
		let urls = [
			'',
			'/company-stats',
			'/trials',
			'/companies-with-modules',
			'/person-list',
			'/features',
			'/ml-stats',
			'/restore-data',
			'/sage-signup',
			'/nova-studio',
			'/client-contacts-backfill',
		];
		let texts = [
			'Impersonate',
			'Company stats',
			'Trials',
			'Modules',
			'Person list',
			'Feature Flags',
			'ML Stats',
			'Restore Data',
			'Sage Signup',
			'Nova Studio',
			'Contacts back-fill',
		];

		// If the company is not Forecast, we remove all other tabs except for the impersonate tab
		if (process.env.CIRCLE_BRANCH === 'production' && this.props.viewer.company.id !== 'Q29tcGFueTox') {
			urls = [''];
			texts = ['Impersonate'];
		}

		const prefix = window.location.pathname.includes('missioncontrol') ? '/missioncontrol' : '/control';
		return (
			<div className="mission-control-header">
				<NavLink aria-label="homepage" to="">
					<LogoWrapper>
						<Logo size={LOGO_SIZE.SMALL} />
					</LogoWrapper>
				</NavLink>
				{urls.map((url, index) => this.getButton(prefix + url, texts[index], index))}
			</div>
		);
	}
}

export default createFragmentContainer(withRouter(MissionControlHeader), {
	viewer: graphql`
		fragment missionControlHeader_viewer on Viewer {
			email
			actualPersonId
			firstName
			lastName
			company {
				id
				name
			}
		}
	`,
});
